import { RpcBaseData } from '../rpc-base';

/**
 * RPC extension broker request name and version.
 */
export class RpcExtensionBrokerRequestKey {
    public static command = 'ExtensionBrokerRequest';
    public static version = '0.1.0';
}

/**
 * RPC extension broker response name and version.
 */
export class RpcExtensionBrokerResponseKey {
    public static command = 'ExtensionBrokerResponse';
    public static version = '0.1.0';
}

/**
 * RPC Extension Broker Request.
 */
export interface RpcExtensionBrokerRequest extends RpcBaseData {
    /**
     * Request specific Id to track completion.
     */
    requestId: string;

    /**
     * The extension request payload. Payload contract depends on the requestType
     */
    payload: any;
}

/**
 * RPC Extension Broker Request.
 */
export interface RpcExtensionBrokerRequestResult {
    /**
     * Request specific Id to track completion.
     */
    requestId: string;

    /**
     * Error if one occurred
     */
    error?: any;

    /**
     * The extension response payload (if there was no error)
     */
    payload?: any;
}
